var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Config View")]),_c('v-row',[_c('v-col',{attrs:{"cols":"12","xs":"12","sm":"12","lg":"10"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }